<div [ngClass]="{'card-container-shadow': !this.withoutContainer}">
  <div class="title-label mb-sm text-subtitle-bold-upper">
    <p>{{ title }}</p>
    <p class="text-info text-lower-initial mt-xxs">{{ description }}</p>
  </div>
  <div class="kcal d-flex align-items-center" *ngIf="hasData">
    <img loading="lazy" src="./../../../assets/images/icons/icons8-chocolatina-100.png" alt="">
    <p class="text-info"><span class="text-title-md text-bold">{{ kcal.toFixed(2) }} kcal</span>
      en total</p>
  </div>
  <ngx-charts-advanced-pie-chart
    class="tw-hidden md:tw-block"
    *ngIf="data.length> 0 && hasData"
    [label]="'Total en gramos'"
    [view]="view"
    [scheme]="colorSchemeMacronutrients"
    [results]="data"
    >
    <ng-template #tooltipTemplate let-model="model" class="tooltip-container">
      <div class="tooltip-chart">
        <p class="name">{{model.name}}</p>
        <nz-divider nzType="vertical"></nz-divider>
        <p class="value">{{model.value}}</p>
      </div>
    </ng-template>
  </ngx-charts-advanced-pie-chart>

  <ngx-charts-pie-chart
    class="tw-block md:tw-hidden"
    *ngIf="data.length> 0 && hasData"
    [view]="view"
    [scheme]="colorSchemeMacronutrients"
    [results]="data"
    [gradient]="false"
    [legendTitle]="''"
    [legend]="true"
    [doughnut]="false"
    [legendPosition]="this.legendPosition.Below"
  >
    <ng-template #tooltipTemplate let-model="model" class="tooltip-container">
      <div class="tooltip-chart">
        <p class="name">{{model.name}}</p>
        <nz-divider nzType="vertical"></nz-divider>
        <p class="value">{{model.value}}</p>
      </div>
    </ng-template>
  </ngx-charts-pie-chart>

  <div *ngIf="data.length === 0 || !hasData" class="empty-ingredients-charts"
    [ngStyle]="{'height': !hasData ? 'auto' : data.length> 0 ? view[1] + 'px' : '200px'}">
    <span class="text-info md:tw-text-left">{{ !hasData ? 'Los tiempos de comida no cuentan con información nutricional' : emptyText }}</span> <!--tw-text-center-->
  </div>
</div>
